import api from '../../utils/service/api';

export const getTeleradiologyQueue = ({ status = '', groupId = '', urgency = '', from = 0, size = 50 } = {}) => {
  const q = new URLSearchParams({ from, size });
  if (status)  q.set('status',   status);
  if (groupId) q.set('group_id', groupId);
  if (urgency) q.set('urgency',  urgency);
  return api({ method: 'get', url: `/api/teleradiology/queue?${q}` });
};

export const getTeleradiologyWorklist = ({ from = 0, size = 50 } = {}) =>
  api({ method: 'get', url: `/api/teleradiology/worklist?from=${from}&size=${size}` });

export const assignTeleradiologyGroup = (requestId, groupId) =>
  api({ method: 'post', url: `/api/teleradiology/requests/${requestId}/assign-group`, data: { group_id: groupId } });

export const claimTeleradiologyRequest = (requestId) =>
  api({ method: 'post', url: `/api/teleradiology/requests/${requestId}/claim` });

export const unclaimTeleradiologyRequest = (requestId) =>
  api({ method: 'post', url: `/api/teleradiology/requests/${requestId}/unclaim` });

export const completeTeleradiologyRequest = (requestId) =>
  api({ method: 'post', url: `/api/teleradiology/requests/${requestId}/complete` });

// Radiologist: reading history (completed studies).
export const getTeleradiologyHistory = ({ from = 0, size = 100 } = {}) =>
  api({ method: 'get', url: `/api/teleradiology/history?from=${from}&size=${size}` });

// Coordinator: cancel a request.
export const cancelTeleradiologyRequest = (requestId) =>
  api({ method: 'post', url: `/api/teleradiology/requests/${requestId}/cancel` });

// Radiologist: reject a claimed study back to coordinator with a reason.
export const rejectTeleradiologyRequest = (requestId, reason) =>
  api({ method: 'post', url: `/api/teleradiology/requests/${requestId}/reject`, data: { reason } });

// Coordinator: completion stats broken down by group and radiologist.
export const getTeleradiologyStats = () =>
  api({ method: 'get', url: '/api/teleradiology/stats' });

// Coordinator: full aggregated analytics for the analytics dashboard.
export const getTeleradiologyAnalytics = (days = 30) =>
  api({ method: 'get', url: `/api/teleradiology/analytics?days=${days}` });

// Group management
export const getTeleradiologyGroups = () =>
  api({ method: 'get', url: '/api/teleradiology/groups' });
export const createTeleradiologyGroup = (data) =>
  api({ method: 'post', url: '/api/teleradiology/groups', data });
export const updateTeleradiologyGroup = (id, data) =>
  api({ method: 'put', url: `/api/teleradiology/groups/${id}`, data });
export const deleteTeleradiologyGroup = (id) =>
  api({ method: 'delete', url: `/api/teleradiology/groups/${id}` });

// Team management (coordinator only)
export const getTeleradiologyMembers = () =>
  api({ method: 'get', url: '/api/teleradiology/members' });
export const createTeleradiologyMember = (data) =>
  api({ method: 'post', url: '/api/teleradiology/members', data });
export const updateMemberGroup = (userId, groupId) =>
  api({ method: 'put', url: `/api/teleradiology/members/${userId}/group`, data: { group_id: groupId } });
export const resetMemberPassword = (userId, password) =>
  api({ method: 'post', url: `/api/teleradiology/members/${userId}/reset-password`, data: { password } });

// Hospital admin: get teleradiology status for all studies submitted from their hospital.
// Returns { data: [...], status_map: { [studyInstanceUID]: { id, status, urgency } }, total }
export const getMyTeleradiologyRequests = () =>
  api({ method: 'get', url: '/api/studies/teleradiology/my-requests?size=500' });
